@if (group) {
  <div class="parameters-group" [class]="clazz">
    @if (group.label) {
      <div class="parameters-group-header">
        {{ resolveValue(group.label) }}
      </div>
    }
    @for (value of group.values; track value; let last = $last) {
      <div>
        @if (showOnlyIf(value)) {
          <div class="parameter" [class.last]="last">
            @if (value.icon || value.label) {
              <pr-label
                [name]="value.icon"
                [width]="14"
                [height]="14"
                [class]="value?.options?.class"
                [tooltip]="value.tooltip"
                labelClass="fs-14"
              >
                {{ value.label }}</pr-label
              >
            }
            <span
              class="parameter-value"
              [class]="options?.class + ' ' + value?.options?.class"
              >{{ evalValue(value) }}</span
            >
          </div>
        }
      </div>
    }
  </div>
}
